"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMostRecentScoreFromProblemUserStats = exports.mergeScoreMaps = exports.areBaseScoresEqual = exports.buildEmptyScoreMapWithContentTree = exports.isIScoreImmediatelyAboveBase = exports.isIScoreBaseScore = exports.isIScoreNonBaseScore = exports.mergeBaseScores = exports.getEmptyBaseScore = void 0;
const contentTree_1 = require("../../ContentTree/contentTree");
const ContentPath_1 = require("../../ContentPath");
const getEmptyBaseScore = () => {
    return { score: 0, points: 0 };
};
exports.getEmptyBaseScore = getEmptyBaseScore;
const mergeBaseScores = (baseScoreA, baseScoreB) => {
    return {
        score: baseScoreA.score + baseScoreB.score,
        points: baseScoreA.points + baseScoreB.points,
    };
};
exports.mergeBaseScores = mergeBaseScores;
const isIScoreNonBaseScore = (score) => {
    return 'scores' in score;
};
exports.isIScoreNonBaseScore = isIScoreNonBaseScore;
const isIScoreBaseScore = (score) => {
    return !(0, exports.isIScoreNonBaseScore)(score);
};
exports.isIScoreBaseScore = isIScoreBaseScore;
const isIScoreImmediatelyAboveBase = (score) => {
    if (!(0, exports.isIScoreNonBaseScore)(score)) {
        throw new Error(`Expected a non-base score but got base score: ${JSON.stringify(score, null, 2)}`);
    }
    else {
        return !(0, exports.isIScoreNonBaseScore)(score.scores[0]);
    }
};
exports.isIScoreImmediatelyAboveBase = isIScoreImmediatelyAboveBase;
const buildEmptyScoreMapWithContentTree = (contentTree) => {
    const scoreMap = new Map();
    const addEmptyBaseScoreForContentPath = (contentPath) => {
        scoreMap.set((0, ContentPath_1.hashContentPath)(contentPath), (0, exports.getEmptyBaseScore)());
    };
    (0, contentTree_1.walkContentTree)(contentTree, [], (node, path) => addEmptyBaseScoreForContentPath(path), (node, path) => addEmptyBaseScoreForContentPath(path));
    return scoreMap;
};
exports.buildEmptyScoreMapWithContentTree = buildEmptyScoreMapWithContentTree;
const areBaseScoresEqual = (baseScoreA, baseScoreB) => {
    return (baseScoreA.score === baseScoreB.score &&
        baseScoreB.points === baseScoreB.points);
};
exports.areBaseScoresEqual = areBaseScoresEqual;
const mergeScoreMaps = (toScoreMap, fromScoreMap) => {
    // Mutates toScoreMap by merging all data from "fromScoreMap" into "toScoreMap" in-place
    for (const [hashedContentPath, baseScore] of fromScoreMap.entries()) {
        let newBaseScore;
        if (toScoreMap.has(hashedContentPath)) {
            newBaseScore = (0, exports.mergeBaseScores)(toScoreMap.get(hashedContentPath), baseScore);
        }
        else {
            newBaseScore = baseScore;
        }
        toScoreMap.set(hashedContentPath, newBaseScore);
    }
};
exports.mergeScoreMaps = mergeScoreMaps;
const getMostRecentScoreFromProblemUserStats = (problemUserData) => {
    return {
        // floor latest attempt score at 0 because if not attempted, encoded as -1
        score: problemUserData.latestAttemptScore > 0
            ? problemUserData.latestAttemptScore
            : 0,
        points: problemUserData.points,
    };
};
exports.getMostRecentScoreFromProblemUserStats = getMostRecentScoreFromProblemUserStats;
//# sourceMappingURL=index.js.map